import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/dashboard.service';

@Component({
  selector: 'app-top-departments',
  templateUrl: './top-departments.component.html',
  styleUrls: ['./top-departments.component.scss']
})
export class TopDepartmentsComponent implements OnInit {
  public topDepartments = [];
  constructor(private dashboardService: DashboardService) { }

  ngOnInit(): void {
    //this.getTopPerformers();
  }

  getTopPerformers() {
    this.dashboardService.getTopDepartments()
      .subscribe(statistic => {
        this.topDepartments = statistic.topDepartments;
      });
  }
}
